/*
 * Throttle Resize-triggered Events
 * Wrap your actions in this function to throttle the frequency of firing them off, for better performance, esp. on mobile.
 * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
*/
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
    if (timers[uniqueId]) { clearTimeout(timers[uniqueId]); }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 200;

// reqeustAnimationFrame
(function () {
  var lastTime = 0;
  var vendors = ['webkit', 'moz'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame =
      window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () { callback(currTime + timeToCall); },
        timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }

}());


jQuery(document).ready(function ($) {


  // FUNCTIONS

  // EVENTS

  $('.site__header__nav_toggle, .nav__overlay__toggle').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass('nav--open').removeClass('search--open');

    $('.nav__mobile').animate({ scrollTop: 0 }, 300, 'swing');
  });

  $('.nav__overlay__search_toggle').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('search--open').removeClass('nav--open');

    $('.nav__search').animate({ scrollTop: 0 }, 300, 'swing');
  });

  $('.site__header__search_toggle').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass('search--open').removeClass('nav--open');

    $('.nav__search').animate({ scrollTop: 0 }, 300, 'swing');
  });

  $('.search__overlay__close').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('search--open');
  });

  $('.nav__mobile__submenu__toggle').on('click', function (e) {
    e.preventDefault();

    var my_parent = $(this).parents('.nav__mobile__menu__item');
    var my_submenu = my_parent.find('.nav__mobile__submenu');


    $('.nav__mobile__menu__item').not(my_parent).removeClass('nav__mobile__menu__item--open');
    my_parent.toggleClass('nav__mobile__menu__item--open');

    $('.nav__mobile__submenu').not(my_submenu).slideUp(200);
    my_submenu.slideToggle(200);

  });


  $('body').on('click', function (e) {

    if ($(e.target).closest('.nav__overlay').length === 0 && $(e.target).closest('.site__header__nav_toggle').length === 0 && $(e.target).closest('.nav__overlay__toggle').length === 0) {
      $('body').removeClass('nav--open');
    }

    if ($(e.target).closest('.nav__overlay__search_toggle').length === 0 && $(e.target).closest('.search__overlay').length === 0 && $(e.target).closest('.site__header__search_toggle').length === 0 && $(e.target).closest('.search__overlay__toggle').length === 0) {

      $('body').removeClass('search--open');
    }

  });

  // LANGUAGE SWITCHER
  $('.wpml-ls-link').on('click', function (e) {
    e.preventDefault();
    var $form = $(this).closest('form');
    $form.find('input[name="locale_code"]').val($(this).data('value'));
    $form.trigger('submit');
  });


  // INIT

  if (window.location.hash) {
    var init_hash = window.location.hash.substring(1);
    var init_destination = $('[id="' + init_hash + '"]');
    if (init_destination.length > 0) {
      var init_header_height = $('.site__header--sticky').outerHeight() + 20;
      $('html, body').scrollTop(0);
      $('html, body').animate({
        scrollTop: init_destination.offset().top - init_header_height
      }, 400);
    }
  }

  var headroom_options = {
    offset: 140,
  };

  var headroom = new Headroom($('.site__header--sticky')[0], headroom_options);
  headroom.init();


  $('.nav__mobile__menu__item.current-menu-ancestor > .nav__mobile__submenu__toggle, .nav__mobile__menu__item.current-menu-item > .nav__mobile__submenu__toggle').each(function () {
    var my_toggle = $(this);
    my_toggle.trigger('click');
  });

  // hash navigation check
  $('a[href*="#"]').on('click', function (e) {

    var href = $(this).attr('href');
    var hash = href.substring(href.indexOf('#') + 1);

    var my_destination = $('[id="' + hash + '"]');
    if (my_destination.length > 0) {

      e.preventDefault();

      var header_height = $('.site__header--sticky').outerHeight() + 20;

      $('html, body').animate({
        scrollTop: my_destination.offset().top - header_height
      }, 400);

    }

  });



  // RESIZED

  $(window).on('resize', function () {

    waitForFinalEvent(function () {
    }, timeToWaitForLast, 'main_resize_event');

  });


});